// extracted by mini-css-extract-plugin
module.exports = {"grey350":"rgb(210,210,212)","emptyQuestionContent":"EmptyContent_emptyQuestionContent__326Zz"};